import React from 'react';
import { object, bool, func } from 'prop-types';
import styled from 'styled-components';

import withVisibilityToggle from '../../../../../core/enhancements/withVisibilityToggle';
import extraAdIcon from '../../../../images/extra-ad.svg';
import highlightSilverIcon from '../../../../images/highlight-silver.svg';
import highlightGoldIcon from '../../../../images/highlight-gold.svg';
import highlightDiamondIcon from '../../../../images/highlight-diamond.svg';
import newHighlightDiamondIcon from '../../../../images/new-highlight-diamond.svg';
import visibilityRenewIcon from '../../../../images/visibility-renew.svg';

import highlightBronzeIcon from '../../../../images/highlight-bronze.svg';

const RecommendedBadge = styled.div`
  background-color: #ffffff;
  width: fit-content;
  border-radius: 8px;
  border: solid 1px #e5e5e5;
  color: ${({ label }) => (label ? label.color : '#6e0ad6')};
  font-size: 9px;
  font-weight: bold;
  padding: 4px;
  text-transform: uppercase;
  position: absolute;
  top: -9px;
  left: 50%;
  transform: translateX(-50%);
`;

const ProductContainer = styled.div`
  box-sizing: border-box;
  padding: 0 8px 10px;
  display: inline-block;
`;

const ProductIcon = styled.div`
  display: inline-block;
  text-align: center;
  background: #fff;
  font-size: 13px;
  border-radius: 5px;
  font-weight: bold;
  height: 70px;
  width: 70px;
  position: relative;
  border: ${({ active, isDiamond }) => {
    if (active && isDiamond) {
      return '1px solid #28B5D9';
    } else if (active) {
      return 'solid 1px #6e0ad6';
    }
    return 'solid 1px #e5e5e5';
  }};
  box-shadow: ${({ active, isDiamond }) => {
    if (active && isDiamond) {
      return '0 0 0 4px rgba(40,181,217,0.18)';
    } else if (isDiamond) {
      return '0 0 10px 0 rgba(42,196,236,0.53)';
    } else if (active) {
      return '0 0 0 4px rgba(110, 10, 214, 0.1)';
    }
    return '';
  }};
  ${({ isDiamond }) => isDiamond && 'z-index: 1000;'}
`;

const ProductImageContainer = styled.div`
  margin: 0;
`;

const ProductImage = styled.img`
  background-position: center;
  background-size: 16px;
  background-repeat: no-repeat;
  box-sizing: border-box;
  display: inline-block;
  height: inherit;
  min-width: 16px;
  min-height: 16px;
  max-width: 44px;
  margin-bottom: ${({ isDiamond }) => (isDiamond ? '5px' : '0px')};
  margin-top: ${({ isDiamond }) => (isDiamond ? '-6px' : '8px')};
`;

const RecommendedLabel = withVisibilityToggle(RecommendedBadge);

function ProductPickerIcon({
  product, active, onClickIcon,
}) {
  const {
    type: productType, title, label,
  } = product;

  const icons = {
    PACKAGE_DIAMOND_MONTHLY: newHighlightDiamondIcon,
    PACKAGE_DIAMOND: highlightDiamondIcon,
    PACKAGE_SILVER: highlightSilverIcon,
    PACKAGE_GOLD_BIWEEKLY: highlightGoldIcon,
    PACKAGE_GOLD: highlightGoldIcon,
    // PAID_AD: 'product-mini-image--basic',
    PACKAGE_BRONZE: highlightBronzeIcon,
    PAID_RENEWAL: extraAdIcon,
    FREE_RENEWAL: extraAdIcon,
    PAID_VISIBILITY_RENEWAL: visibilityRenewIcon,
    FREE_VISIBILITY_RENEWAL: visibilityRenewIcon,
    PAID_AD: extraAdIcon,
    BUNDLE_HV_GOLD: highlightGoldIcon,
    BUNDLE_HV_GOLD_BIWEEKLY: highlightGoldIcon,
    BUNDLE_HV_DIAMOND_MONTHLY: newHighlightDiamondIcon,
  };

  return (
    <ProductContainer>
      <ProductIcon active={active} onClick={() => onClickIcon(product)}>
        <ProductImageContainer>
          <RecommendedLabel label={label} showIf={label}>
            {(label && label.text) || 'Mais Vendido'}
          </RecommendedLabel>
          <ProductImage src={icons[productType]} alt={title} />
        </ProductImageContainer>
        <div>{title}</div>
      </ProductIcon>
    </ProductContainer>
  );
}

ProductPickerIcon.propTypes = {
  product: object.isRequired,
  active: bool.isRequired,
  onClickIcon: func.isRequired,
};


export default ProductPickerIcon;
